import {
  ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidCommandResult,
  ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidRequest,
  postOrdersPublicIDWorkflowClientInvoiceRecurringPaymentPaymentCalendarItemIDPrepaidSendInvoiceAndPay,
} from "Api/Api";
import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
  getFetchStateDefaultValue,
  handleFailureCase,
  handleRequestCase,
  handleSuccessCase,
} from "State/Utils";
import { getPaymentCalendarItemsAsync } from "State/OrderWorkflow/Slices/GetPaymentCalendarItemsSlice";
import { getOrderWorkflowStepsAsync } from "State/OrderWorkflow/Slices/OrderWorkflowStepsSlice";
import { getOrderDetailAsync } from "State/Orders/Detail/OrderDetailSlice";

export const sendAndPayPrepaidPaymentCalendarItemAsync = createAsyncAction(
  "@orderWorkflow/SEND_AND_PAY_PREPAID_PAYMENT_CALENDAR_ITEM_REQUEST",
  "@orderWorkflow/SEND_AND_PAY_PREPAID_PAYMENT_CALENDAR_ITEM_RESPONSE",
  "@orderWorkflow/SEND_AND_PAY_PREPAID_PAYMENT_CALENDAR_ITEM_FAILURE",
)<
  {
    orderPublicID: string;
    paymentCalendarItemID: number;
    request: ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidRequest;
  },
  ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidCommandResult,
  Error
>();

function* sendAndPayPrepaidPaymentCalendarItem(
  action: ReturnType<typeof sendAndPayPrepaidPaymentCalendarItemAsync.request>,
): Generator {
  try {
    const { data, error, status } = yield* call(
      postOrdersPublicIDWorkflowClientInvoiceRecurringPaymentPaymentCalendarItemIDPrepaidSendInvoiceAndPay,
      action.payload.request,
      action.payload.orderPublicID,
      action.payload.paymentCalendarItemID,
    );

    if (status === 200) {
      yield put(
        getPaymentCalendarItemsAsync.request({
          publicID: action.payload.orderPublicID,
        }),
      );
      yield put(
        getOrderWorkflowStepsAsync.request({
          publicID: action.payload.orderPublicID,
        }),
      );
      yield put(sendAndPayPrepaidPaymentCalendarItemAsync.success(data));

      yield put(
        getOrderDetailAsync.request({
          publicID: action.payload.orderPublicID,
        }),
      );

      return;
    }

    yield put(
      sendAndPayPrepaidPaymentCalendarItemAsync.failure(
        mapAPIErrorResponse(error ?? data),
      ),
    );
  } catch (err) {
    yield put(sendAndPayPrepaidPaymentCalendarItemAsync.failure(err as Error));
  }
}
export function* sendAndPayPrepaidPaymentCalendarItemSaga() {
  yield takeLatest(
    getType(sendAndPayPrepaidPaymentCalendarItemAsync.request),
    sendAndPayPrepaidPaymentCalendarItem,
  );
}

export const sendAndPayPrepaidPaymentCalendarItemSlice = createSlice({
  initialState:
    getFetchStateDefaultValue<ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidCommandResult>(
      false,
    ),
  name: "@orderWorkflow/sendAndPayPrepaidPaymentCalendarItemSlice",
  reducers: {
    resetSlice: () =>
      getFetchStateDefaultValue<ClientPrepaidInvoiceRecurringPaymentSendInvoiceAndSetPaidCommandResult>(
        false,
      ),
  },
  extraReducers: builder => {
    handleRequestCase(sendAndPayPrepaidPaymentCalendarItemAsync, builder);
    handleSuccessCase(sendAndPayPrepaidPaymentCalendarItemAsync, builder);
    handleFailureCase(sendAndPayPrepaidPaymentCalendarItemAsync, builder);
  },
});

export const { resetSlice } = sendAndPayPrepaidPaymentCalendarItemSlice.actions;
